import { useAuthStore } from '@/store/auth'
import { isElectron } from '@/utils/device-type'
import { loadImage } from '@/utils/load-image'

import type { PrinterDriver } from '../types'

export default class Browser implements PrinterDriver {
  constructor() {}

  async printImage(canvas: HTMLCanvasElement) {
    const auth = useAuthStore()
    const locationId = auth.locationId
    const demoLocationId = import.meta.env.VITE_APP_DEMO_LOCATION_ID
    const isDemoLocation = locationId === demoLocationId

    if (isDemoLocation) return

    if (!isElectron) {
      const image = await loadImage(canvas.toDataURL('image/png'))
      const w = window.open('')
      w?.document.write(image.outerHTML)
    }
  }

  openCashDrawer() {
    // Not supported in browser
  }
}
